import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import FormComment from './components/FormComment'
import CommentsList from './components/CommentsList'
import { getComments } from './api'
import { useEffect, useState } from 'react'

const ModalComments = ({
  setOpenModalComments,
  openModalComments,
  ...props
}) => {
  const handleClose = () => {
    setOpenModalComments(false)
  }

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="modal-comments"
      open={openModalComments}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Comments</DialogTitle>
      <DialogContent>{props.children}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  )
}

const Comments = ({
  record,
  type,
  openModalComments,
  setOpenModalComments,
}) => {
  const [comments, setComments] = useState([])
  const fetchComments = async () => {
    const res = await getComments(record.id, type)
    setComments(() => res?.data)
  }
  useEffect(() => {
    fetchComments()
  }, [record?.id, type])

  return (
    <ModalComments
      openModalComments={openModalComments}
      setOpenModalComments={setOpenModalComments}
    >
      <>
        <FormComment
          record={record}
          type={type}
          refresh={() => {
            fetchComments()
          }}
        />

        <CommentsList
          comments={comments}
          setComments={setComments}
          ticketId={record.id}
          type={type}
        />
      </>
    </ModalComments>
  )
}
export default Comments
